<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import ChartEnergyEfficiency from '$lib/PageSections/Charts/ChartEnergyEfficiency/ChartEnergyEfficiency.svelte';
	import ChartNoiseReduction from '$lib/PageSections/Charts/ChartNoiseReduction/ChartNoiseReduction.svelte';
</script>

<div
	class="
   w-full overflow-hidden rounded-2xl bg-indow-grey-medium p-3
   md:p-12
 "
>
	<h2 class="text-white">Indow vs Replacement Windows</h2>

	<p class="text-white">
		Adding Indow inserts to an existing window can make your windows perform as
		well (or better!) than a replacement window, but at a fraction of the cost
		and without the hassle and disruption of installing new windows.
	</p>

	<div
		class="
    mb-6 grid grid-cols-1 gap-0
    lg:grid-cols-2 lg:gap-6
  "
	>
		<Bubble
			backgroundColor="white"
			class="
     px-3!
     sm:px-4!
   "
		>
			<h3>Energy Efficiency Comparison</h3>
			<ChartEnergyEfficiency />
		</Bubble>

		<Bubble
			backgroundColor="white"
			class="
     px-3!
     sm:px-4!
   "
		>
			<h3>Noise Reduction Comparison</h3>
			<ChartNoiseReduction />
		</Bubble>
	</div>

	<h3 class="text-2xl text-white">Improve Resale Value</h3>

	<p class="text-white">
		Indow inserts can also help increase the resale value of your home by
		improving your energy efficiency in a much more cost-effective way than
		replacements.
	</p>

	<Button color="white" href="/how-to/increase-home-resale-value"
		>Learn More</Button
	>
</div>
